import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteOptionGroup } from '../../api/apiOptionGroups';
import { toast } from 'react-hot-toast';
import parseError from '../../utils/parseError';

/**
 * Hook to delete an option group
 */
export const useDeleteOptionGroup = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteOptionGroupMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteOptionGroup,
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['optionGroups'] });
            toast.success(res?.data?.message);
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { deleteOptionGroupMutate, isDeleting };
};
